import { c as _c } from "react/compiler-runtime";
import { analysisQueryKeys, createQueryFn } from '../../../lib/entry.js';
import { useSuspenseQuery } from '../../../tanstack/entry.js';
import { getGameAnalysis } from '../../actions/analysis/entry.js';
const fetcher = createQueryFn(getGameAnalysis);
/**
 * Hook to get game analysis.
 *
 * @param product product to get game analysis for
 * @param drawNumber draw number to get game analysis for
 * @param queryOptions optional query configuration options
 * @returns game analysis data
 */
export function useGameAnalysis(product, drawNumber, queryOptions) {
  const $ = _c(9);
  let t0;
  if ($[0] !== drawNumber || $[1] !== product) {
    t0 = analysisQueryKeys.gameAnalysis(product, drawNumber);
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryOptions || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[5] = queryOptions;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSuspenseQuery(t3);
}